<template>
    <DashboardPage />
</template>

<script>
import { defineComponent } from 'vue'
import DashboardPage from './DashboardPage.vue'

export default defineComponent({
    name: 'DashboardView',
    components: {
        DashboardPage
    }
})
</script>
